<template>
    <div class="page-body">
      <div class="container-fluid">
        <div class="page-title">
          <div class="row">
            <div class="col-6">
              <h3></h3>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <Loader :loading="isLoading" />
          <loader-component v-if="isLoading" :loading="isLoading" />
          <div class="row">
            <div class="col-sm-12">
              <div class="card">
                <div class="card-body add-post">
                    <div class="row my-3">
                      <!-- Mostrar: dropdown para seleccionar usuarios por página -->
                      <div class="d-flex align-items-center mb-3">
                        <span class="me-2">Mostrar:</span>
                        <select 
                          v-model="itemsPerPage" 
                          @change="resetPagination"
                          class="form-select w-auto px-4 py-[9px] bg-white rounded-md text-black text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                        >
                          <option :value="10">10</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                        <span class="ms-2">registros</span>
                      </div>
                      <div class="filters-container d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
                        <!-- Botón a la izquierda -->
                        <button @click="goToAccountForm" class="custom-create-btn mb-2 mb-md-0">
                            <span class="custom-create-btn-text">Crear Cuenta</span>
                        </button>
                        <!-- Buscador -->
                        <div class="filters-group d-flex align-items-center gap-2">
                          <select 
                            v-model="selectedStatus" 
                            class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                          >
                            <option value="">Todos los estatus</option>
                            <option value="Activo">Activo</option>
                            <option value="Desactivado">Desactivado</option>
                          </select>
                          <!-- Input del buscador -->
                          <input
                            type="text"
                            class="w-64 px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                            placeholder="Buscar"
                            v-model="searchQuery"
                          />
                        </div>  
                    </div>
                    <div class="row my-3">
                      <div class="w-full ">
                      </div>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="min-w-full bg-white border border-gray-200 rounded-lg">
                            <thead class="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
                                <tr>
                                <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell">ID</th>
                                <th class="py-3 px-6 text-style-custom text-left">Nombre</th>
                                <th class="py-3 px-6 text-style-custom text-left hidden md:table-cell">Descripción</th>
                                <th class="py-3 px-6 text-style-custom text-left">Estatus</th>
                                <th class="py-3 px-6 text-style-custom text-left">Acciones</th>
                                </tr>
                            </thead>
                            <tbody class="text-gray-600 text-sm font-light">
                                <tr
                                v-for="(account, index) in filteredAccounts"
                                :key="index"
                                class="border-b border-gray-200 hover:bg-gray-100"
                                >
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap hidden md:table-cell" :class="{'opacity-50':  account.status === 'Desactivado'}">{{ account.id }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  account.status === 'Desactivado'}">{{ account.name }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap hidden md:table-cell" :class="{'opacity-50':  account.status === 'Desactivado'}">{{ account.description }}</td>
                                <!-- <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  account.status === 'Desactivado'}">{{ account.status }}</td> -->
                                <td class="py-3 px-6 custom-width-text">
                                  <span class="status-indicator" :class="{ 
                                    'bg-red': account.status === 'Desactivado', 
                                    'bg-green': account.status === 'Activo',
                                    }">
                                    {{ account.status }}
                                  </span>
                                  </td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">
                                  <div class="relative" ref="el => menuContainers.push(el)">
                                    <!-- Contenedor clickeable -->
                                    <div 
                                      class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-200"
                                      @click.stop="toggleMenu(account.id)"
                                    >
                                      <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        width="17" 
                                        height="4" 
                                        viewBox="0 0 17 4" 
                                        fill="none"
                                      >
                                        <path 
                                          fill-rule="evenodd" 
                                          clip-rule="evenodd" 
                                          d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" 
                                          fill="#FF4265"
                                        />
                                      </svg>
                                    </div>

                                    <!-- Menú desplegable -->
                                    <div 
                                      v-show="menuVisible === account.id" 
                                      :class="{
                                        'absolute right-0 bg-white border shadow-lg mt-1 w-48 z-10': true,
                                        'bottom-full mb-1': index === filteredAccounts.length - 1, // Si es el último registro, despliega hacia arriba
                                        'top-full mt-1': index !== filteredAccounts.length - 1 // De lo contrario, despliega hacia abajo
                                      }"
                                    >
                                      <ul class="py-1">
                                        <!-- Editar -->
                                        <li 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer" 
                                          @click="editAccount(account.id)"
                                        >
                                          Editar
                                        </li>
                                        <!-- Activar -->
                                        <li 
                                          v-if="account.status === 'Desactivado'" 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-green-500" 
                                          @click="confirmActive(account.id)"
                                        >
                                          Activar
                                        </li>
                                        <!-- Desactivar -->
                                        <li 
                                          v-else 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500" 
                                          @click="deleteAccount(account.id)"
                                        >
                                          Desactivar
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                        <DeleteModal
                          v-if="showModal"
                          :visible="showModal"
                          :roleId="roleId"
                          @close="showModal = false"
                          @confirm="confirmDelete"
                        />
                    </div>
                    <div class="flex justify-between items-center w-full">
                      <div class="w-[278px] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal">
                        Mostrando {{ currentPage }} de {{ totalPages }}
                      </div>
                      <!-- Pagination Controls -->
                      <div class="flex justify-end items-center p-2">
                      <button 
                        @click="changePage(currentPage - 1)" 
                        :disabled="currentPage === 1"
                        class="px-3 py-2 border border-[#FFD8DF] bg-white text-[#FF4265] disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        &lt;
                      </button>
  
                      <!-- Números de página -->
                    <div class="flex gap-0 items-center">
                      <button
                        v-for="pageNumber in totalPages" 
                        :key="pageNumber" 
                        @click="changePage(pageNumber)" 
                        class="px-3 py-2 border border-[#FFD8DF]"
                        :class="{
                        'bg-[#FF4265] text-white': pageNumber === currentPage,
                        'bg-white text-[#FF4265]': pageNumber !== currentPage
                        }"
                      >
                      {{ pageNumber }}
                      </button>
                    </div>
  
                      <button 
                        @click="changePage(currentPage + 1)" 
                        :disabled="currentPage === totalPages"
                        class="px-3 py-2 border border-[#FFD8DF] bg-white text-[#FF4265] disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                          &gt;
                      </button>
                    </div>
                    </div>
                  </div>
                  <head>
                      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                </head>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script setup>
  import { ref, onMounted} from 'vue';
  import axios from 'axios';
  import { computed } from "vue";
  import { useStore } from 'vuex';
  import 'vue-toastification/dist/index.css';
  import Loader from '@/components/loaderComponent.vue';
  import DeleteModal from '@/components/catalogue/Modal/DeleteAccountModal.vue';
  import { useRouter } from 'vue-router';
  
  // Referencias y estado
  const isLoading = ref(true); // Inicializamos isLoading
  const page = ref(1); // Página actual
  const searchQuery = ref("");  // Para almacenar el término de búsqueda
  const selectedStatus = ref("");
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  const accounts = ref([]); // Aquí guardaremos todos los roles
  //const showDeleteModal = ref(false); // Controla la visibilidad del modal
  const showModal = ref(false); // Controla la visibilidad del modal
  const selectedAccountId = ref(null);
  const router = useRouter();
  const currentPage = ref(1);
  const itemsPerPage = ref(10); // Number of items to show per page
  const menuVisible = ref(null);
  const menuContainers = ref([]); 

  // Métodos
  
    //obtener los cuentas
    async function fetchAccounts() {
        try {
            let options = {
            headers: {
                'Authorization': `Bearer ${session.value.token_api}`
            }
            };
            const response = await axios.get(
            `${process.env.VUE_APP_API_BASE_URL}/account-all`, options
            );

            if (response.status === 401) {
            store.dispatch('clearUserSession');
            }

            // Accede a los cargos en response.data.cargos
            if (response.status === 200 && response.data?.accounts) {
              accounts.value = response.data.accounts.map(account => ({
                ...account,
                status: translateStatus(account.status), // Traduce el estado de la cuenta
              }));
            } else {
              console.error("Error en la respuesta de la API: estructura inesperada");
            }
        } catch (error) {
            console.error("Error al obtener los planes:", error);
        } finally {
            isLoading.value = false;
        }
    }
    const translateStatus = (status) => {
      const statusTranslations = {
        active: 'Activo',
        disabled: 'Desactivado',
        // Agrega más traducciones según sea necesario
      };

      return statusTranslations[status] || status; // Devuelve el estado original si no se encuentra traducción
    };
    const deleteAccount = (account_id) => {
    selectedAccountId.value = account_id; // Almacena el ID del usuario
    showModal.value = true
  };

  async function confirmDelete() {
      try {
        // Configuración de los encabezados
        const options = {
          headers: {
            'Authorization': `Bearer ${session.value.token_api}`
          }
        };

        // Envío de la solicitud con el rol_id
        const data = { account_id: selectedAccountId.value };
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/account-delete`,
          data, 
          options
        );

        // Manejo de la respuesta
        if (response.status === 200) {
          showModal.value = false
          console.log("Cuenta eliminado correctamente:", response.data.message);
          fetchAccounts();
          return response.data.message; // Mensaje de éxito desde la API
          
        } else {
          console.error("Error en la respuesta de la API: estructura inesperada");
        }
      } catch (error) {
        console.error(
          "Error al intentar eliminar el cuenta:",
          error.response?.data?.message || error.message
        );
      }
    }
    const confirmActive = async (account_id) => {
      selectedAccountId.value = account_id; // Almacena el ID del usuario
      try {
        let options = {
          headers: {
            'Authorization': `Bearer ${session.value.token_api}`,
            'Content-Type': 'application/json',
          },
        };
        const data = { account_id: selectedAccountId.value };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/account-active`, 
          data, 
          options
        );

        if (response.status === 200) {
          showModal.value = false
          console.log("Cuenta eliminado correctamente:", response.data.message);
          fetchAccounts();
          return response.data.message; // Mensaje de éxito desde la API
          
        } else {
          return response.data.message; 
        }
      } catch (error) {
        console.error('Error al activar el usuario', error);
      }
    };
    const goToAccountForm = () => {
      router.push({ name: 'cuentas-form' });
    };
    const editAccount = (id) => {
      console.log("ID del rol:", id); // Imprime el ID en la consola
      router.push({ name: 'cuentas-form-edit', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
    };
    // Manejo de clics fuera del menú
    const handleClickOutside = (event) => {
      // Si el clic no fue dentro de ningún contenedor de menú, cerrar el menú visible
      if (!menuContainers.value.some(container => container?.contains(event.target))) {
        menuVisible.value = null;
      }
    };

    const toggleMenu = (userId) => {
      menuVisible.value = menuVisible.value === userId ? null : userId;
    };
    const resetPagination = () => {
      page.value = 1; // Reset to first page
    };
    const filteredAccounts= computed(() => {
      // First, filter by search query
      let filtered = !searchQuery.value 
        ? accounts.value 
        : accounts.value.filter(account => 
            account.name.toLowerCase().includes(searchQuery.value.toLowerCase())
          );
        
      if (selectedStatus.value) {
        filtered = filtered.filter(account => 
          account.status === selectedStatus.value
        );
      }
      // Then paginate the filtered results
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return filtered.slice(start, end);
    });

    const totalPages = computed(() => {
      const filtered = !searchQuery.value 
        ? accounts.value 
        : accounts.value.filter(account => 
            account.name.toLowerCase().includes(searchQuery.value.toLowerCase())
          );
      if (selectedStatus.value) {
        return Math.ceil(filtered.filter(account => 
          account.status === selectedStatus.value).length / itemsPerPage.value);
      }
      return Math.ceil(filtered.length / itemsPerPage.value);
    });
    const changePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };

  
  //const showToast = (message) => {
  //successMessage.value = message;
  //setTimeout(() => {
  //  successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  //}, 3000);
  //};
  // Lifecycle hooks
  onMounted(() => {
  fetchAccounts();
  document.addEventListener('click', handleClickOutside);
  });
  
  </script>
  
  <style scoped>
    .card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: none;
    border-radius: 8px;
    }

    .status-indicator {
    display: inline-block;
    padding: 0.2rem 0.5rem;
    border-radius: 9999px;
    color: #4A4A4A;
    text-align: center;
    font-size: 0.875rem; /* Tamaño de texto consistente */
    }
    
    .bg-red {
    background-color: #f8d7da;
    color: #842029;
    }
    .bg-green {
    background-color: #d1e7dd;
    color: #1c5f48;
    }
    .filters-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    }

    .filters-group {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    }

    .custom-create-btn {
    padding: 0.5rem 1rem;
    background-color: #FF4265;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    transition: background-color 0.3s ease;
    white-space: nowrap;
    }

    .custom-create-btn:hover {
    background-color: #e03a5f;
    }

    /* Estilos responsivos */
    @media (max-width: 768px) {
    .filters-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    }
  
    .filters-group {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    }
  
    .filters-group select,
    .filters-group input {
    width: 100%;
    }
    }
    @media (min-width: 640px) {
    .filters-group {
    flex-direction: row;
    flex-wrap: wrap;
    }
    .filter-select,
    .search-input {
    width: auto;
    }
    }

    @media (min-width: 768px) {
    .controls-wrapper {
    flex-direction: column; /* Mantener en columna para que "Mostrar" esté arriba */
    align-items: flex-start; /* Alinea a la izquierda */
    }

    .filters-container {
    flex-direction: row;
    justify-content: space-between; /* Mantiene el botón a la izquierda y los filtros a la derecha */
    width: 100%; /* Asegúrate de que ocupe todo el ancho disponible */
    margin-top: 1rem; /* Añade un margen superior para separar "Mostrar" de los filtros */
    }
    }

    @media (min-width: 1024px) {
    .filters-group {
    flex-wrap: nowrap;
    }
    }
    /* Asegura que la tabla sea scrollable horizontalmente en móvil */
    .overflow-x-auto {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* Suaviza el scroll en iOS */
    }

    /* Opcional: Ajusta el ancho de las celdas visibles en móvil */
    @media (max-width: 767px) {
    .custom-width-text {
    min-width: 120px; /* Evita que las celdas se hagan demasiado estrechas */
    }
}
  </style>